import ChartBarHorizontalCustom from './chartBarHorizontalCustom'
export default ChartBarHorizontalCustom
